import Flashbar from "@amzn/awsui-components-react-v3/polaris/flashbar";
import {EXTERNAL_USER_NOT_ALLOWED_FLASHBAR_HEADER, EXTERNAL_USER_NOT_ALLOWED_FLASHBAR_MESSAGE} from "../util/ConfigConstants";
import * as React from "react";
import { useRouteLoadDurationPublisher } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';

export default function() {
    const publishRouteLoadDuration = useRouteLoadDurationPublisher();
    publishRouteLoadDuration();
    
    const items = [
        {
            type: "error" as const,
            header: EXTERNAL_USER_NOT_ALLOWED_FLASHBAR_HEADER,
            content: EXTERNAL_USER_NOT_ALLOWED_FLASHBAR_MESSAGE,
            dismissible: false
        }
    ];
    
    return <Flashbar items={items} />;
}